module.exports = __webpack_public_path__ + "img/104.8d676b16.jpg";